module.exports = __webpack_public_path__ + "static/media/amazon-pay.a98c540b.png";